<template>
  <v-list subheader dense>
    <v-subheader>Администрирование</v-subheader>
    <v-list-item>
      <v-list-item-action>
        <v-checkbox v-model="adminModeValue" color="primary"></v-checkbox>
      </v-list-item-action>

      <v-list-item-content>
        <v-list-item-title>Режим Администратора</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item :to="{ name: 'manage-article' }">
      <v-list-item-content>
        <v-list-item-title>Новый пост</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import { authComputed, adminOptionsComputed } from '@/store/helpers.js'
export default {
  data() {
    return {
      adminModeValue: null
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    adminModeValue: function(newVal, oldVal) {
      this.$store.dispatch('setUserAdminMode', newVal)
    }
  },
  computed: {
    ...authComputed,
    ...adminOptionsComputed
  },
  mounted() {
    this.adminModeValue = this.adminMode
  }
}
</script>

<style></style>
